import React, { Component } from 'react';
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent';
import Steps from '../../components/Steps/Steps';
import { Link } from "react-router-dom";
import { AppContext } from '../../AppContext'
import SelectedPlan from '../../components/SelectedPlan/SelectedPlan'
import ApiSso from '../../actions/sso';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css'
import auth from '../../actions/auth';


class Login extends Component {

    static contextType = AppContext;

    constructor(props){
        super(props);
        this.state = {
            isLoading: false,
            step: 2,
            email: localStorage.getItem("user_email"),
            password: '',
            status: false,
            read: false,
            validated: {}
        }

        this.handleLogin = this.handleLogin.bind(this);
    }

    componentDidMount(){
        
        this.setState({isLoading: true});

        // Procura parametros na URL 
        const search = this.props.location.search;
        
        console.log(encodeURIComponent(search))

        const user_data = new URLSearchParams(search).get("user_data");
        const iv = new URLSearchParams(search).get("iv");

        console.log('User data: ' + encodeURIComponent(user_data));
        console.log('IV: ' + iv)

        if(search === '') {

            if(auth.login()){
                const { userStep, setUserStep } = this.context;
    
                console.log( userStep )
                setUserStep(2)
                this.setState({isLoading: false});
    
            }else{
                window.location.replace("https://figueira.futebolcardsaude.com.br/acesso");
            }

        }else{
        
            
            ApiSso.post('/external-login', {
                'user_data': encodeURIComponent(user_data),
                'iv': encodeURIComponent(iv)
            }).then((response) => {

                console.log(response)
                
                if(response.data.status == "success"){

                localStorage.setItem('token', response.data.data.token);
                localStorage.setItem('email', response.data.data.email);
                localStorage.setItem('user_email', response.data.data.email);
                localStorage.setItem('account', response.data.data.account);
                localStorage.setItem('user', response.data.data.user);
                localStorage.setItem('document_type', response.data.data.document_type);
                localStorage.setItem('photo', response.data.data.photo);
                localStorage.setItem('isLogged', "true");

                const { userStep, setUserStep, setUserLogged } = this.context;

                console.log( userStep )
                setUserStep(2)
                setUserLogged(true)
                this.props.history.push("/dashboard");
                window.location.reload();
                this.setState({isLoading: false});

                }else{  

                    this.setState({isLoading: false});
                    this.props.history.push("/");
                }

            })

        }

        
        // if(auth.login()){
        //     const { userStep, setUserStep } = this.context;

        //     console.log( userStep )
        //     setUserStep(2)

        // }else{
        //     this.props.history.push("/");
        // }

    }
    
    auth() {
        const client = process.env.REACT_APP_CLIENT;
        const key = process.env.REACT_APP_KEY;

        return ApiSso.post('client', {
            'client': client,
            'key': key
        });
    }

    handleLogin(event) {
        event.preventDefault();
        
        this.setState({isLoading: true});
        
        const { setUserLogged, setUserStep } = this.context;

        this.auth().then(authResponse  => {
            const {email, password} = this.state;

            ApiSso.defaults.headers.common['Authorization'] = authResponse.data.data.token;
            ApiSso.post('user/sign_in', {
                'user': email,
                'password': password,
            }).then((response) => {

                localStorage.setItem('token', response.data.data.token);
                localStorage.setItem('name', response.data.data.people.first_name);
                localStorage.setItem('last_name', response.data.data.people.last_name);
                localStorage.setItem('email', response.data.data.email);
                localStorage.setItem('user_email', response.data.data.email);
                localStorage.setItem('account', response.data.data.account);
                localStorage.setItem('user', response.data.data.user);
                localStorage.setItem('document_type', response.data.data.document_type);
                localStorage.setItem('photo', response.data.data.photo);
                localStorage.setItem('isLogged', "true");

                setUserLogged(true)
                // setUserStep(2)
                this.props.history.push("/dashboard");
                window.location.reload();

                this.setState({isLoading: false});

            }).catch((error) => {

                this.setState({isLoading: false});

                toastr.options = {
                    positionClass : 'toast-top-full-width',
                    hideDuration: 300,
                    timeOut: 60000
                }
                toastr.clear()
                setTimeout(() => toastr.error('Senha inválida, tente novamente.'), 300)
                
            });
        })
    }

    render(){
        return(
            <div>

                <SelectedPlan />

                {this.state.isLoading ? (
                        <LoadingComponent />
                    ) : ( <></> )}

                <div className="position-relative">
                    <div className="p-5">
                        <form onSubmit={event => this.handleLogin(event)} className="text-center form login-form">
                            <h4 className="mb-3">Digite sua senha e continue</h4>
                            <input type="email" className="form-control" disabled value={this.state.email} onChange={(e) => {this.setState({email: e.target.value})}} placeholder="Digite seu e-mail" />
                            <input type="password" className="form-control" value={this.state.password} onChange={(e) => {this.setState({password: e.target.value})}} placeholder="Digite sua senha" />
                            <input type="submit" className="form-submit" value="Continuar" /><br /><br />
                            <Link to="/password-recovery" className="link-default">Não lembro minha senha.</Link>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default Login